import { MedicoesInput, ObjetivoInput } from 'graphql/types.generated'
import { parseNumber } from 'util/number'
import { MedicoesPanelModel } from 'view/atendimentos/components/MedicoesPanel/MedicoesPanel'

import { ObjetivoFormModel } from './ObjetivoForm'
import { convertPuericulturaToInput } from './puericultura/converter'

export const convertObjetivoFormToInput = (form: ObjetivoFormModel): ObjetivoInput =>
  form && {
    texto: form.texto,
    medicoes: convertMedicoesToInput(form),
    necessidadesEspeciais: form.necessidadesEspeciais,
    puericultura:
      form.atendimentosEspecificos?.puericultura &&
      convertPuericulturaToInput(form.atendimentosEspecificos.puericultura),
  }

export const convertMedicoesToInput = (form: ObjetivoFormModel): MedicoesInput => {
  const { openedAccordions, ...rest } = form.medicoes
  return {
    dum: form.dum,
    vacinacaoEmDia: form.vacinacaoEmDia,
    ...convertMedicoesPanelToInput(rest),
  }
}
export const convertMedicoesPanelToInput = (medicoes: MedicoesPanelModel): MedicoesInput => ({
  altura: parseNumber(medicoes?.altura),
  circunferenciaAbdominal: parseNumber(medicoes?.circunferenciaAbdominal),
  frequenciaCardiaca: parseNumber(medicoes?.frequenciaCardiaca),
  frequenciaRespiratoria: parseNumber(medicoes?.frequenciaRespiratoria),
  perimetroCefalico: parseNumber(medicoes?.perimetroCefalico),
  perimetroPanturrilha: parseNumber(medicoes?.perimetroPanturrilha),
  peso: parseNumber(medicoes?.peso),
  pressaoArterialDiastolica: parseNumber(medicoes?.pressaoArterialDiastolica),
  pressaoArterialSistolica: parseNumber(medicoes?.pressaoArterialSistolica),
  saturacaoO2: parseNumber(medicoes?.saturacaoO2),
  glicemia: parseNumber(medicoes?.glicemia),
  temperatura: parseNumber(medicoes?.temperatura),
  tipoGlicemia: medicoes?.tipoGlicemia,
})
